import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

// Background priority keeps the nudge resolution out of the SSR markup and out of hydration, so its
// publishes can't force a synchronous update into a still-hydrating Suspense boundary. It also avoids
// holding the page-load UFO experience open while the chunk loads.
export const AutomationNudgeActionsLoader: LoadableType<{ contentId: string }> = LoadableBackground(
	{
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-AutomationNudgeActionsLoader" */ '../src/automation-nudge-actions/AutomationNudgeActionsLoader.tsx'
				)
			).AutomationNudgeActionsLoader,
	},
);
